import script from "./MainIpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainIpPage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/main.css?vue&type=style&index=0&id=a41f862e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a41f862e"]])

export default __exports__